import { defineComponent as _defineComponent } from 'vue'
import { Vue } from 'vue-class-component';
// import router from '@/router';
import { ElLoading, ElMessage } from 'element-plus';
import applicationService from '../services/applicationService';
import ErrorCode from '../constants/ErrorCode';
import ApplicationOneSignalConfig from '@/models/applications/applicationOneSignalConfig';
import ApplicationJPushConfig from '@/models/applications/applicationJPushConfig';
import ApplicationHMSCoreConfig from '@/models/applications/applicationHMSCoreConfig';
import ApplicationMiConfig from '@/models/applications/applicationMiConfig';

// export default class AddApplication extends Vue {


//   //手机系统展示列表数据
//   // OSTypeOptions = [
//   //   {
//   //     label: 'IOS',
//   //     value: 1,
//   //   },
//   //   {
//   //     label: 'Android',
//   //     value: 0,
//   //   },
//   // ];


//   // //下拉框推送平台
//   // PlateTypeOptions = [
//   //   {
//   //     label: 'OneSignal',
//   //     value: 0,
//   //   },
//   //   {
//   //     label: '极光',
//   //     value: 1,
//   //   },
//   //   {
//   //     label: 'HMSCore',
//   //     value: 2,
//   //   },
//   //   {
//   //     label: '小米',
//   //     value: 3
//   //   }, {
//   //     label: 'OPPO',
//   //     value: 4
//   //   },
//   //   {
//   //     label: 'VIVO',
//   //     value: 5
//   //   }
//   // ];

//   // centerDialogVisible = false;

//   // pushPlate = {
//   //   AppKey: '',
//   //   AppId: '',
//   //   Sound: '',
//   //   IsVoip: false,
//   //   PlateType: 0,
//   //   OSType: 0,
//   //   Package: '',
//   // };



//  const createAppform = {
//     AppName: '',
//     AppDescription: '',

//     // UserOnlineStatus: '',
//     // VoiceCommunication: '',
//     // HasVOIP: false,
//     // JPushConfig: new Array<ApplicationJPushConfig>(),
//     // OneSignalConfig: new Array<ApplicationOneSignalConfig>(),
//     // HmsPushConfig: new Array<ApplicationHMSCoreConfig>(),
//     // MiPushConfig: new Array<ApplicationMiConfig>(),
//   };


//   private rules = {
//     AppName: [{ required: true, message: '请输入应用名', trigger: 'blur' }],
//     AppDescription: [{ required: true, message: '请输入描述', trigger: 'blur' }],
//   };



//   //弹窗配置取消事件
//   // cancelPushData() {
//   //   this.pushPlate.AppId = '';
//   //   this.pushPlate.AppKey = '';
//   //   this.pushPlate.Sound = '';
//   //   this.pushPlate.Package = '';
//   //   this.pushPlate.IsVoip = false;
//   //   this.pushPlate.OSType = 0;
//   //   this.pushPlate.PlateType = 0;
//   //   this.centerDialogVisible = false;
//   // }


//   //弹窗配置保存事件
//   // savePushData(): void {


//   //   if (this.pushPlate.PlateType === 0) {
//   //     //万信
//   //     this.createAppform.OneSignalConfig.push({
//   //       configType: this.pushPlate.IsVoip ? 1 : 0,
//   //       appKey: this.pushPlate.AppKey,
//   //       appId: this.pushPlate.AppId,
//   //       pushPlateform: this.pushPlate.OSType,
//   //       iosSound: this.pushPlate.Sound || '',
//   //       bundleId: this.pushPlate.Package || '',
//   //     });
//   //   }

//   //   //极光
//   //   if (this.pushPlate.PlateType === 1) {
//   //     //极光
//   //     this.createAppform.JPushConfig.push({
//   //       configType: this.pushPlate.IsVoip ? 1 : 0,
//   //       appKey: this.pushPlate.AppKey,
//   //       appId: this.pushPlate.AppId,
//   //       bundleId: this.pushPlate.Package || '',
//   //       pushPlateform: this.pushPlate.OSType,
//   //     });
//   //   }


//   //   //HMS Core
//   //   if (this.pushPlate.PlateType === 2) {
//   //     //HMS Core
//   //     this.createAppform.HmsPushConfig.push({
//   //       configType: this.pushPlate.IsVoip ? 1 : 0,
//   //       appKey: this.pushPlate.AppKey,
//   //       appId: this.pushPlate.AppId,
//   //       bundleId: this.pushPlate.Package || '',
//   //       pushPlateform: this.pushPlate.OSType,
//   //     });
//   //   }

//   //   //小米推送
//   //   if (this.pushPlate.PlateType === 3) {
//   //     this.createAppform.MiPushConfig = this.createAppform.MiPushConfig || [];
//   //     this.createAppform.MiPushConfig.push({
//   //       configType: this.pushPlate.IsVoip ? 1 : 0,
//   //       appKey: (this.pushPlate.AppKey || '').trim(),
//   //       appId: (this.pushPlate.AppId || '').trim(),
//   //       bundleId: (this.pushPlate.Package || '').trim(),
//   //       pushPlateform: this.pushPlate.OSType,
//   //     });
//   //   }




//   //   //重置数据
//   //   this.pushPlate.AppId = '';
//   //   this.pushPlate.AppKey = '';
//   //   this.pushPlate.Sound = '';
//   //   this.pushPlate.Package = '';
//   //   this.pushPlate.IsVoip = false;
//   //   this.pushPlate.OSType = 0;
//   //   this.pushPlate.PlateType = 0;
//   //   this.centerDialogVisible = false;
//   // }

//   //页面描述保存
//   save(): void {


//     const form: any = this.$refs.createForm;

//     form.validate((valid: boolean) => {
//       if (valid) {
//         const loadingInstance = ElLoading.service({
//           lock: true,
//           text: 'Loading',
//           spinner: 'el-icon-loading',
//           background: 'rgba(0, 0, 0, 0.7)',
//         });

//         let formdata = {
//           appName: this.createAppform.AppName,
//           appDescription: this.createAppform.AppDescription,

//           // hasVOIP: this.createAppform.HasVOIP,
//           // oneSignalConfig: this.createAppform.OneSignalConfig,
//           // jPushConfig: this.createAppform.JPushConfig,
//           // hmsPushConfig: this.createAppform.HmsPushConfig,
//           // mipushConfig: this.createAppform.MiPushConfig,
//           // callbackUrls: [
//           //   {
//           //     callbackUrlType: 1,
//           //     url: this.createAppform.UserOnlineStatus || '',
//           //   },
//           //   {
//           //     callbackUrlType: 2,
//           //     url: this.createAppform.VoiceCommunication || '',
//           //   },
//           // ],
//         };

//         console.log(formdata, '页面表单输入参数');

//         const result = applicationService.create(formdata);

//         result.then((res) => {
//           loadingInstance.close();
//           if (res.code === ErrorCode.Success) {
//             ElMessage.success(res.msg);
//             form.resetFields();
//             this.$router.push('/Application');
//           } else {
//             ElMessage.error(res.msg);
//           }
//         })
//           .catch((error) => {
//             loadingInstance.close();
//             console.info(error);
//             ElMessage.error('未知错误');
//           });
//       }
//     });
//   }
// }


import { useRouter } from 'vue-router'
import { reactive, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddApplication',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter()
const createForm = ref(null)
const createAppform = ref({
  AppName: '',
  AppDescription: '',
  hasVOIP: false
})

const rules = reactive({
  AppName: [{ required: true, message: '请输入应用名', trigger: 'blur' }],
  AppDescription: [{ required: true, message: '请输入描述', trigger: 'blur' }],
})

//页面添加保存事件
const save = () => {
  if (!createForm.value) return;
  createForm.value.validate((valid: boolean) => {
    if (valid) {
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '正在保存，请稍候...',
        background: 'rgba(255, 255, 255, 0.6)',
      });

      applicationService.create(createAppform.value)
        .then((res: any) => {
          loadingInstance.close();
          if (res.code === ErrorCode.Success) {
            ElMessage.success(res.msg);
            createForm.value.resetFields();
            router.push('/Application');
          } else {
            ElMessage.error(res.msg);
          }
        })
        .catch((error: any) => {
          loadingInstance.close();
          console.info(error);
          ElMessage.error('未知错误');
        });
    }
  });
}



const __returned__ = { router, createForm, createAppform, rules, save }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})